import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/data/site";
import { useInView } from "@/hooks/useReveal";

const ROWS = [
  { icon: Phone, key: "phone", getLabel: () => COMPANY.phoneDisplay, getHref: () => COMPANY.phoneHref, testid: "contact-phone", sub: "Hétfő–Szombat · 07:00 – 18:00" },
  { icon: Mail, key: "email", getLabel: () => COMPANY.email, getHref: () => `mailto:${COMPANY.email}`, testid: "contact-email", sub: "E-mailben is elérhető" },
  { icon: MapPin, key: "area", getLabel: () => COMPANY.serviceArea, getHref: () => null, testid: "contact-area", sub: "Magyarország" },
];

export default function Contact({ showHeader = true }) {
  const [ref, inView] = useInView();

  return (
    <section
      id="kapcsolat"
      ref={ref}
      data-testid="contact-section"
      className="section"
      style={{ background: "var(--ink)" }}
    >
      <div className="site-container">
        {showHeader && (
          <div className={`reveal ${inView ? "in-view" : ""}`} style={{ marginBottom: 40, maxWidth: 760 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
              <span style={{ height: 1, background: "var(--gold)", width: 32 }} />
              <span className="eyebrow" data-testid="contact-eyebrow">06 — Kapcsolat</span>
            </div>
            <h2 className="h2" data-testid="contact-h2" style={{ margin: 0 }}>
              Hívjon vagy írjon. <span style={{ color: "var(--gold)" }}>Hamarosan visszahívom.</span>
            </h2>
            <p className="lead" style={{ marginTop: 20, maxWidth: 560, fontSize: 16 }}>
              A felmérés ingyenes, az ajánlat tételes. Keressen telefonon vagy e-mailben, és egyeztetünk egy időpontot.
            </p>
          </div>
        )}

        <div className={`reveal reveal-1 ${inView ? "in-view" : ""}`} style={{ maxWidth: 620 }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {ROWS.map((row, i) => {
              const Icon = row.icon;
              const href = row.getHref();
              const inner = (
                <>
                  <span style={{
                    width: 44, height: 44, display: "inline-flex", alignItems: "center", justifyContent: "center",
                    border: "1px solid var(--line)", flexShrink: 0,
                  }}>
                    <Icon size={18} strokeWidth={1.6} color="var(--gold)" />
                  </span>
                  <div>
                    <div style={{ fontSize: 19, color: "var(--text)", fontWeight: 600, letterSpacing: "-0.01em" }}>
                      {row.getLabel()}
                    </div>
                    <div className="small" style={{ marginTop: 4 }}>{row.sub}</div>
                  </div>
                </>
              );
              const baseStyle = {
                display: "flex", alignItems: "center", gap: 16,
                textDecoration: "none", color: "var(--text)",
                padding: "22px 0", borderBottom: "1px solid var(--line)",
              };
              if (i === 0) baseStyle.borderTop = "1px solid var(--line)";
              return href ? (
                <a key={row.key} href={href} data-testid={row.testid} style={baseStyle}>{inner}</a>
              ) : (
                <div key={row.key} data-testid={row.testid} style={baseStyle}>{inner}</div>
              );
            })}
          </div>

          <p className="small" style={{ marginTop: 24, maxWidth: 360 }}>
            Cégadatok (adószám, kamarai szám) — egyeztetni kell.
          </p>
        </div>
      </div>
    </section>
  );
}
